/**
 * Zopup - Company API
 *
 * OpenAPI spec version: v1
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

// Third party library imports
import { HttpClient, HttpContext, HttpEvent, HttpParams, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// Zopup library imports
import {
    CompanyCompactDtoListWebApiPagedResponse,
    CompanyCreateCommand, CompanyDtoWebApiResponse,
    CompanyUpdateCommand,
    VerificationStatus
} from '@zopup/zop-types';

// Internal project imports
import { COMPANIES_API_BASE_PATH } from '../api-tokens';
import { BaseService } from '../api.base.service';

@Injectable({
    providedIn: 'root'
})
export class CompanyService extends BaseService {

    constructor(
        protected httpClient: HttpClient,
        @Inject(COMPANIES_API_BASE_PATH) private apiBasePath: string
    ) {
        super();
        this.basePath = this.apiBasePath;
        this.configuration.basePath = this.basePath;
    }

    /**
     * @param xTenantId 
     * @param isActive 
     * @param companyType 
     * @param verificationStatus 
     * @param orderBy 
     * @param isOrderByDescending 
     * @param searchText 
     * @param pageNumber 
     * @param pageSize 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public companyGet(xTenantId: string, isActive?: boolean, companyType?: string, verificationStatus?: VerificationStatus, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<CompanyCompactDtoListWebApiPagedResponse>;
    public companyGet(xTenantId: string, isActive?: boolean, companyType?: string, verificationStatus?: VerificationStatus, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CompanyCompactDtoListWebApiPagedResponse>>;
    public companyGet(xTenantId: string, isActive?: boolean, companyType?: string, verificationStatus?: VerificationStatus, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CompanyCompactDtoListWebApiPagedResponse>>;
    public companyGet(xTenantId: string, isActive?: boolean, companyType?: string, verificationStatus?: VerificationStatus, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling companyGet.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>isActive, 'IsActive');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>companyType, 'CompanyType');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>verificationStatus, 'VerificationStatus');
        if (orderBy) {
            orderBy.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'OrderBy');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>isOrderByDescending, 'IsOrderByDescending');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>searchText, 'SearchText');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNumber, 'PageNumber');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'PageSize');

        let localVarHeaders = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            localVarHeaders = localVarHeaders.set('x-tenant-id', String(xTenantId));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/Company`;
        return this.httpClient.request<CompanyCompactDtoListWebApiPagedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param id 
     * @param xTenantId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public companyIdGet(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<CompanyDtoWebApiResponse>;
    public companyIdGet(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CompanyDtoWebApiResponse>>;
    public companyIdGet(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CompanyDtoWebApiResponse>>;
    public companyIdGet(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling companyIdGet.');
        }
        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling companyIdGet.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            localVarHeaders = localVarHeaders.set('x-tenant-id', String(xTenantId));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/Company/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<CompanyDtoWebApiResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param xTenantId 
     * @param xRequestId 
     * @param companyCreateCommand 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public companyPost(xTenantId: string, xRequestId?: string, companyCreateCommand?: CompanyCreateCommand, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<CompanyDtoWebApiResponse>;
    public companyPost(xTenantId: string, xRequestId?: string, companyCreateCommand?: CompanyCreateCommand, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CompanyDtoWebApiResponse>>;
    public companyPost(xTenantId: string, xRequestId?: string, companyCreateCommand?: CompanyCreateCommand, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CompanyDtoWebApiResponse>>;
    public companyPost(xTenantId: string, xRequestId?: string, companyCreateCommand?: CompanyCreateCommand, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling companyPost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            localVarHeaders = localVarHeaders.set('x-request-id', String(xRequestId));
        }
        if (xTenantId !== undefined && xTenantId !== null) {
            localVarHeaders = localVarHeaders.set('x-tenant-id', String(xTenantId));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/Company`;
        return this.httpClient.request<CompanyDtoWebApiResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: companyCreateCommand,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param xTenantId 
     * @param companyUpdateCommand 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public companyPut(xTenantId: string, companyUpdateCommand?: CompanyUpdateCommand, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<CompanyDtoWebApiResponse>;
    public companyPut(xTenantId: string, companyUpdateCommand?: CompanyUpdateCommand, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CompanyDtoWebApiResponse>>;
    public companyPut(xTenantId: string, companyUpdateCommand?: CompanyUpdateCommand, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CompanyDtoWebApiResponse>>;
    public companyPut(xTenantId: string, companyUpdateCommand?: CompanyUpdateCommand, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling companyPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            localVarHeaders = localVarHeaders.set('x-tenant-id', String(xTenantId));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/Company`;
        return this.httpClient.request<CompanyDtoWebApiResponse>('put', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: companyUpdateCommand,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }
}
